export default function ProgressBarArticle({width = 0}) {
    return (
        <div style={{width: '80%'}} className={`h-2 relative`}>
            <div className={`w-full h-2 left-0 top-0 absolute bg-divider-medium rounded-lg`} />
            <div style={{ width: `${width}%` }}
                className={`h-2 left-0 top-0 absolute bg-sucess-main rounded-lg`} />
        </div>
    )
}